import * as React from "react";
import { MutableRefObject, ReactElement, ReactNode } from "react";

import "./FlexColumn_style.css";

type Props = Readonly<{
    children?: ReactNode;
    width?: "full" | "half" | "quarter" | "auto" | string | number;
    style?: React.CSSProperties | undefined;
    className?: string;
    onClick?: (event?: React.MouseEvent) => void;
    onBlur?: () => void;
    gap?: 4 | 8 | 12 | 16;
    forwardRef?: MutableRefObject<any>;
    justifyContent?: "start" | "center" | "end";
}>;

export default function FlexColumn({children, width, style, className, onClick, onBlur, gap, forwardRef, justifyContent = "start"}: Props): ReactElement {
    const widthClass =
        width === "full"
            ? "full-width"
            : width === "half"
            ? "half-width"
            : width === "quarter"
            ? "quarter-width"
            : width === "auto"
            ? "auto-width"
            : null;

    const justifyClass = `justify-${justifyContent}`;

    return (
        <div
            ref={forwardRef}
            className={`flex-column${
                className != null ? ` ${className}` : ""
            }${gap != null ? ` gap-${gap}` : ``}${
                widthClass === null ? `` : ` ${widthClass}`
            }${justifyClass != null ? ` ${justifyClass}` : ""}`}
            style={style ?? undefined}
            onClick={onClick}
            onBlur={onBlur}
        >
            {children}
        </div>
    );
}
